<template>
  <div class="mod-sys__organization">
    <!-- 查询条件：组织类型 组织编号 所属集团 公司 品牌 网点类型 是否主要网点 所在城市 状态-->
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm"
               @keyup.enter.native="getDataListMerge()" @submit.native.prevent>
        <el-row class="margb10">
          <!-- 组织类型 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('organization.orgType')">
              <el-select disabled v-model="dataForm.orgType"
                         :placeholder="$t('organization.orgType')"
                         @change="orgTypeChange()">
                <el-option v-for="(item,index) in typeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 公司编号 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('organization.orgCode')">
              <el-input v-model="dataForm.orgCode"
                        type="text"
                        :placeholder="$t('organization.orgCode')"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 所属集团 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('organization.parentDealerGroupId')">
              <el-select v-model="dataForm.parentDealerGroupId"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="parentDealerGroupSearch">
                <el-option v-for="item in parentDealerGroupList"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 公司(中英文全程/NSC NO./BBA NO.模糊搜索) -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('organization.companyMessage')">
              <el-input v-model="dataForm.company"
                        type="text"
                        :placeholder="$t('organization.companyMessage')"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!--&lt;!&ndash; 所属经销商 &ndash;&gt;-->
          <!--<el-col :span="5"-->
                  <!--class="padt5">-->
            <!--<el-form-item :label="$t('organization.parentDealeId')">-->
              <!--<el-select v-model="dataForm.parentDealeId"-->
                         <!--remote-->
                         <!--clearable-->
                         <!--filterable-->
                         <!--reserve-keyword-->
                         <!--:placeholder="$t('user.input')"-->
                         <!--:remote-method="parentDealerSearch">-->
                <!--<el-option v-for="item in parentDealerList"-->
                           <!--:key="item.orgId"-->
                           <!--:label="item.name"-->
                           <!--:value="item.orgId">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</el-form-item>-->
          <!--</el-col>-->
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         @click="getDataListMerge()"
                         type="primary">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="resetModify()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row class="margb10">
            <!-- 品牌 -->
            <el-col :span="5"
                    class="padt5">
              <el-form-item :label="$t('organization.brandCodes')">
                <el-select v-model="dataForm.brandCodes"
                           :placeholder="$t('organization.brandCodes')"
                           clearable>
                  <el-option v-for="(item,index) in brandArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--&lt;!&ndash; 网点类型 &ndash;&gt;-->
            <!--<el-col :span="5"-->
                    <!--class="padt5">-->
              <!--<el-form-item :label="$t('organization.networkType')">-->
                <!--<el-select v-model="dataForm.networkType"-->
                           <!--:placeholder="$t('organization.networkType')"-->
                           <!--clearable>-->
                  <!--<el-option v-for="(item,index) in networkTypeArr"-->
                             <!--:key="index"-->
                             <!--:label="item.name"-->
                             <!--:value="item.code">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
            <!-- * 所在区域 -->
            <el-col :span="5"
                    class="padt5">
              <el-form-item :label="$t('organization.area')"
                            prop="areaCode">
                <el-select v-model="dataForm.areaCode"
                           :placeholder="$t('organization.area')"
                           clearable>
                  <el-option v-for="(item,index) in areaArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 所在城市 -->
            <el-col :span="5"
                    class="padt5">
              <el-form-item :label="$t('organization.cityIds')">
                <address-select :level="2"
                                v-model="dataForm.regionIds"
                                :placeholder="$t('organization.cityIds')">
                </address-select>
              </el-form-item>
            </el-col>
            <!-- 状态 -->
            <el-col :span="5"
                    class="padt5">
              <el-form-item :label="$t('organization.status')">
                <el-select v-model="dataForm.statusModify"
                           :placeholder="$t('organization.status')"
                           clearable>
                  <el-option v-for="(item,index) in statusList"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="margb10"
                  style="margin-top: 5px">
            <!--&lt;!&ndash; 开业时间起止 &ndash;&gt;-->
            <!--<el-col :span="10"-->
                    <!--class="padt5">-->
              <!--<el-form-item :label="$t('organization.openDate')"-->
                            <!--style="width: 100%!important;">-->
                <!--<el-date-picker v-model="dataForm.openDateModify"-->
                                <!--type="daterange"-->
                                <!--value-format="yyyy-MM-dd"-->
                                <!--:start-placeholder="$t('organization.startData')"-->
                                <!--:end-placeholder="$t('organization.endData')"-->
                                <!--:clearable="true"-->
                                <!--:editable='false'-->
                                <!--style="width: 90%">-->
                <!--</el-date-picker>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          </el-row>
          <el-row class="margb10">
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="search">
        <!-- 导出模板 -->
        <el-button type="primary"  @click="exportTemple">{{ $t('res.departmentValue.export') }}
        </el-button>
        <!-- 导入建议值 -->
        <el-button  type="primary" @click="importValue()">{{ $t('res.departmentValue.importStandardValue') }}
        </el-button>
      </div>
      <el-table :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%;">
        <el-table-column prop="orgCode"
                         align="center"
                         fixed="left"
                         :label="$t('organization.orgCode')"
                         show-overflow-tooltip
                         key="2">
        </el-table-column>
        <el-table-column v-if="this.dataForm.orgType === '50'"
                         prop="nscNo"
                         align="center"
                         width="120"
                         :label="$t('organization.nscNo')"
                         show-overflow-tooltip
                         key="9">
        </el-table-column>
        <el-table-column v-if="this.dataForm.orgType === '50'"
                         prop="bbaNo"
                         width="120"
                         align="center"
                         :label="$t('organization.bbaNo')"
                         show-overflow-tooltip
                         key="10">
        </el-table-column>
        <el-table-column prop="abbreviation"
                         :label="$t('organization.abbreviationZh')"
                         width="150"
                         header-align="center"
                         show-overflow-tooltip
                         key="4">
        </el-table-column>
        <el-table-column prop="name"
                         align="left"
                         :label="$t('organization.nameZh')"
                         width="150"
                         show-overflow-tooltip
                         header-align="center"
                         key="5">
        </el-table-column>
        <el-table-column prop="abbreviationEn"
                         align="left"
                         :label="$t('organization.abbreviationEn')"
                         width="150"
                         header-align="center"
                         show-overflow-tooltip
                         key="6">
        </el-table-column>
        <el-table-column prop="nameEn"
                         align="left"
                         :label="$t('organization.nameEn')"
                         width="150"
                         show-overflow-tooltip
                         header-align="center"
                         key="7">
        </el-table-column>
        <el-table-column prop="contacter"
                         align="center"
                         :label="$t('organization.contacter')"
                         show-overflow-tooltip
                         key="8">
        </el-table-column>
        <el-table-column prop="regionIds"
                         align="left"
                         :formatter="cityFormatter"
                         :label="$t('organization.cityIds')"
                         width="120"
                         header-align="center"
                         show-overflow-tooltip
                         key="18">
        </el-table-column>
        <el-table-column v-if="this.dataForm.orgType !== '50' && this.dataForm.orgType !== '60'"
                         prop="status"
                         align="center"
                         :formatter="statusFormatter"
                         :label="$t('organization.status')"
                         show-overflow-tooltip
                         key="19">
        </el-table-column>
        <el-table-column v-if="this.dataForm.orgType === '50'"
                         prop="dealerShipStatus"
                         align="center"
                         width="100"
                         :formatter="dealerShipStatus"
                         :label="$t('organization.dealerShipStatus')"
                         show-overflow-tooltip
                         key="21">
        </el-table-column>
        <el-table-column prop="networkType"
                         align="center"
                         :label="$t('organization.networkType')"
                         show-overflow-tooltip
                         key="23">
        </el-table-column>
        <el-table-column prop="brandCodes"
                         align="center"
                         :formatter="brandFormatter"
                         :label="$t('organization.brandCodes')"
                         show-overflow-tooltip
                         key="24">
        </el-table-column>
        <el-table-column v-if="this.dataForm.orgType === '50'"
                         prop="dealerShipScale"
                         align="center"
                         width="100"
                         :formatter="formatterDealerSize"
                         :label="$t('organization.dealerSize')"
                         show-overflow-tooltip
                         key="25">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         width="100"
                         :label="$t('handle')"
                         key="31">
          <template slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 140px!important;">
                <!--查看建议值-->
                <el-dropdown-item @click.native="seeStandardValue(scope.row)">{{ $t('res.departmentValue.checkStandardValue') }}
                </el-dropdown-item>
                <!--查看组织架构-->
                <el-dropdown-item @click.native="seeOrgTree(scope.row)">{{ $t('res.departmentValue.seeOrgTree') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
      <!--建议值导入-->
      <import-excel v-bind:visible="importDialog"
                    v-bind:url="importUrl"
                    v-bind:isShowNote=true
                    v-on:closeDialogImport="closeDialogImport"></import-excel>
    </el-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddressSelect from '@/components/address-select'
import Vue from 'vue'
import ToggleDiv from '@/components/toggle-div'
import { getRegionNameList } from '@/utils'
import importExcel from '@/components/rm/import-excel/index'
// import * as index from '../../../utils/circular.js'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/rm/orgList',
        getDataListIsPage: true,
        deleteURL: '/sys/org/delete',
        exportURL: '/sys/org/export'
      },
      dataForm: { // 查询条件
        orgCode: '',
        orgType: '50',
        company: '',
        status: '',
        dealerShipStatus: '',
        statusModify: '',
        parentDealerGroupId: '',
        parentDealeId: '',
        openDateModify: '',
        openDateStart: '',
        openDateEnd: '',
        areaCode: '',
        regionIds: [],
        brandCodes: '',
        networkType: '',
        mainNetworkFlag: ''
      }, // 查询条件
      typeArr: _this.enums['orgType'], // 组织类型
      statusList: _this.enums['openStatus'], // 状态下拉框
      statusArr: _this.enums['status'], // 状态
      openStatussArr: _this.enums['openStatus'], // 开业状态
      brandArr: _this.enums['brandCode'], // 品牌
      networkTypeArr: this.enums['networkType'], // 网点类型
      confirmStateArr: this.enums['confirmState'], // 是否主要网点
      areaArr: this.enums['area'], // 所在区域
      parentDealerGroupList: [], // 所属集团
      parentDealerList: [], // 所属经销商
      dataList: [], // 列表数据
      dataListLoading: false,
      importExcelVisible: false,
      isShow: false, // 展开更多
      /////////////////////////////
      // 导入建议值
      importDialog: false,
      // 导入年度目标接口路径
      importUrl: '/talent/positionstandardvalue/import',
    }
  },
  components: {
    AddressSelect,
    ToggleDiv,
    'import-excel': importExcel
  },
  methods: {
    resetModify() {
      this.page = 1
      this.dataForm = {
        orgCode: '',
        orgType: '50',
        company: '',
        status: '',
        dealerShipStatus: '',
        statusModify: '',
        parentDealerGroupId: '',
        parentDealeId: '',
        openDateModify: '',
        openDateStart: '',
        openDateEnd: '',
        areaCode: '',
        regionIds: [],
        brandCodes: '',
        networkType: '',
        mainNetworkFlag: ''
      }
      this.getDataList()
    },
    orgTypeChange() {
      this.dataForm.statusModify = ''
      this.dataForm.status = ''
      this.dataForm.dealerShipStatus = ''
      if (this.dataForm.orgType === '50' || this.dataForm.orgType === '60') {
        this.statusList = { ...this.openStatussArr }
      } else {
        this.statusList = { ...this.statusArr }
      }
      this.page = 1
      if (this.dataForm.openDateModify !== '' && this.dataForm.openDateModify) {
        if (this.dataForm.openDateModify.length === 2) {
          this.dataForm.openDateStart = this.dataForm.openDateModify[0]
          this.dataForm.openDateEnd = this.dataForm.openDateModify[1]
        }
      } else {
        this.dataForm.openDateStart = ''
        this.dataForm.openDateEnd = ''
      }
      this.getDataList()
    },
    getDataListMerge() {
      this.page = 1
      if (this.dataForm.statusModify) {
        if (this.dataForm.orgType === '50' || this.dataForm.orgType === '60') {
          this.dataForm.dealerShipStatus = this.dataForm.statusModify
          this.dataForm.status = ''
        } else {
          this.dataForm.dealerShipStatus = ''
          this.dataForm.status = this.dataForm.statusModify
        }
      } else {
        this.dataForm.status = ''
        this.dataForm.dealerShipStatus = ''
      }
      if (this.dataForm.openDateModify !== '' && this.dataForm.openDateModify) {
        if (this.dataForm.openDateModify.length === 2) {
          this.dataForm.openDateStart = this.dataForm.openDateModify[0]
          this.dataForm.openDateEnd = this.dataForm.openDateModify[1]
        }
      } else {
        this.dataForm.openDateStart = ''
        this.dataForm.openDateEnd = ''
      }
      this.getDataList()
    },
    // 搜索所属集团
    parentDealerGroupSearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          orgType: '40',
          name: queryString
        }).then((res, total, code, data) => {
        this.parentDealerGroupList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索所属经销商
    parentDealerSearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          orgType: '50',
          name: queryString
        }).then((res, total, code, data) => {
        this.parentDealerList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 操作列下拉选项
    gotoView(type, id) {
      if (type === 'view') {
        this.$router.push({
          name: 'sys-organization-view',
          query: {
            orgId: id
          }
        })
      } else if (type === 'update') {
        // 广播通知需要清空表单
        this.$router.push({
          name: 'sys-organization-add-or-update',
          query: {
            orgId: id
          }
        })
        this.$eventHub.$emit(this.GLOBAL.ACTIVATED_ORG, 'activated')
      } else if (type === 'delete') {
        this.deleteOrg(id)
      }
    },
    // 删除
    deleteOrg(row) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        this.$request.post(
          this.mixinViewModuleOptions.deleteURL,
          {
            orgId: row.orgId,
            parentOrgId: row.parentOrgId
          }
        ).then((res) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.getDataList()
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    },
    // 不知道怎么传入自定义参数(即传入两个自定义参数——自定义标识位和列表中的值)，暂时弃用ele提供的回调方法
    handleCommand(command) {
      // console.warn(command)
    },
    // 数据字典字段取值
    orgTypeFormatter(row) {
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    statusFormatter(row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    confirmFormatter(row) {
      return Vue.filter('coverEnum')(row.mainNetworkFlag, 'confirmState')
    },
    dealerShipStatus(row) {
      return Vue.filter('coverEnum')(row.dealerShipStatus, 'openStatus')
    },
    networkStatus(row) {
      return Vue.filter('coverEnum')(row.dealerShipStatus, 'openStatus')
    },
    networkType(row) {
      return Vue.filter('coverEnum')(row.networkType, 'networkType')
    },
    brandFormatter(row) {
      return Vue.filter('coverEnumList')(row.brandCodes, 'brandCode', ',')
    },
    mainNetworkFlagFormatter(row) {
      return Vue.filter('coverEnum')(row.mainNetworkFlag, 'confirmState')
    },
    formatterDealerSize (row) {
      return Vue.filter('coverEnum')(row.dealerShipScale, 'DealerSize')
    },
    // 城市格式返回
    cityFormatter(row) {
      return getRegionNameList(row.regionIds)
    },
    // 格式化时间没有时分秒
    openDateFormatter(row) {
      if (row.openDate !== '' && row.openDate) {
        return Vue.filter('formatDateNoTime')(row.openDate)
      } else {
        return ''
      }
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getDataList()
    },
    checkParam() {
      let clvPid = this.$route.query.clv_pid
      let clvTimestamp = this.$route.query.clv_timestamp
      let memberid = this.$route.query.memberid
      let clvSeq = this.$route.query.clv_seq
      let clvParams = this.$route.query.clv_params
      let clvMd5 = this.$route.query.clv_md5
      let clvStatus = this.$route.query.clv_status
      let clvKey = this.$route.query.clv_key
      if (clvPid) {
        this.$request.post('/sys/callBack',
          {
            clv_pid: clvPid,
            clv_timestamp: clvTimestamp,
            memberid: memberid,
            clv_seq: clvSeq,
            clv_params: clvParams,
            clv_md5: clvMd5,
            clv_status: clvStatus,
            clv_key: clvKey
          }
        ).then((res, total, code, data) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    //////////////////////////////////////////////////////////////////////////////////
    // 年度目标模板导出
    exportTemple () {
      // download 参数 url, params, 报表名
      this.$request.downloadRm('/talent/positionstandardvalue/export', this.$t('res.departmentValue.exportTemple'), {})
    },
    // 建议值导入
    importValue () {
      this.importDialog = true
    },
    // 关闭导入弹框
    closeDialogImport () {
      this.importDialog = false
    },
    // 查看建议值
    seeStandardValue (row) {
      let query = {}
      if (row) {
        query.orgId = row.orgId
        query.dealerSize = row.dealerShipScale
      }
      let name = 'ochart-orgstandardvaluelist'
      this.$router.push({
        name: name,
        query: query
      })
    },
    seeOrgTree (row) {
      console.log(row)
      this.$router.push({
        name: 'ochart-orgtree',
        query: {
          orgId: row.orgId,
          dealerSize: row.dealerShipScale,
          orgCode: row.orgCode
        }
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.ORG_TREE_ONE, '')
    }
  },
/*  beforeMount () {
    let arry = []
    for (let i = 0; i < this.areaArr.length; i++) {
      if (this.areaArr[i].dictStatus == '1') {
        arry.push(this.areaArr[i])
      }
    }
      this.areaArr = arry
  },*/
  mounted() {
    console.log('mounted')
  }
}
</script>

<style lang="scss" scoped>
  .search {
    margin-bottom: 10px;
  }
</style>
